import {
  CalendarOutlined,
  TeamOutlined,
  BarChartOutlined,
  SettingOutlined,
  ScheduleOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  CheckSquareOutlined,
  SoundOutlined,
  ReadOutlined,
  HomeOutlined,
  BankOutlined,
  UserOutlined,
  WalletOutlined,
  SearchOutlined,
  SafetyCertificateOutlined,
  HistoryOutlined,
  DashboardOutlined,
  BellOutlined,
} from '@ant-design/icons';

import { ROUTES } from '../constants/routes';
import { isMenuItemVisible } from './panelMenuAccess';

export const DASHBOARD_MENU_ITEM = { key: ROUTES.DASHBOARD, icon: <DashboardOutlined />, label: 'داشبورد' };

export const MAIN_MENU_DEFS = [
  DASHBOARD_MENU_ITEM,
  { key: ROUTES.MEETINGS, icon: <ScheduleOutlined />, label: 'جلسات' },
  { key: ROUTES.MEETING_GROUPS, icon: <FolderOpenOutlined />, label: 'کارگروه‌ها' },
  { key: ROUTES.ROOMS, icon: <HomeOutlined />, label: 'اتاق‌ها' },
  // اطلاعیه‌ها موقتاً از منو پنهان است (isMenuItemVisible → false؛ مسیر /announcements فعال می‌ماند)
  { key: ROUTES.ANNOUNCEMENTS, icon: <SoundOutlined />, label: 'اطلاعیه‌ها' },
  { key: ROUTES.NOTIFICATIONS, icon: <BellOutlined />, label: 'اعلان‌ها' },
  // قالب دستور جلسه موقتاً از منو پنهان است (مسیر /agenda-templates فعال می‌ماند)
  { key: ROUTES.FILES, icon: <FolderOpenOutlined />, label: 'فایل‌ها' },
  { key: ROUTES.ACTION_ITEMS, icon: <CheckSquareOutlined />, label: 'اقدام‌ها' },
  { key: ROUTES.MINUTES, icon: <FileTextOutlined />, label: 'صورت جلسات' },
  { key: ROUTES.TRANSCRIPTS, icon: <ReadOutlined />, label: 'رونوشت‌ها' },
  { key: ROUTES.STT_JOBS, icon: <SoundOutlined />, label: 'تبدیل گفتار' },
  { key: ROUTES.CALENDAR, icon: <CalendarOutlined />, label: 'تقویم' },
  { key: ROUTES.USERS, icon: <TeamOutlined />, label: 'کاربران' },
  { key: ROUTES.ROLES_AND_PERMISSIONS, icon: <SafetyCertificateOutlined />, label: 'نقش‌ها و دسترسی‌ها' },
  { key: ROUTES.ORGANIZATIONS, icon: <BankOutlined />, label: 'سازمان‌ها' },
  { key: ROUTES.REPORTS, icon: <BarChartOutlined />, label: 'گزارش‌ها' },
  { key: ROUTES.SEARCH, icon: <SearchOutlined />, label: 'جستجو' },
];

export const BILLING_MENU_ITEM = { key: ROUTES.BILLING, icon: <WalletOutlined />, label: 'مالی و پرداخت' };
export const CALENDAR_MENU_ITEM = { key: ROUTES.CALENDAR, icon: <CalendarOutlined />, label: 'تقویم' };
export const ACTION_ITEMS_MENU_ITEM = { key: ROUTES.ACTION_ITEMS, icon: <CheckSquareOutlined />, label: 'اقدام‌ها' };

export const SUPER_ADMIN_PRIMARY_MENU_DEFS = [
  DASHBOARD_MENU_ITEM,
  { key: ROUTES.MEETINGS, icon: <ScheduleOutlined />, label: 'جلسات' },
  { key: ROUTES.MEETING_GROUPS, icon: <FolderOpenOutlined />, label: 'کارگروه‌ها' },
  { key: ROUTES.ROOMS, icon: <HomeOutlined />, label: 'اتاق‌ها' },
  // اطلاعیه‌ها موقتاً از منو پنهان است (isMenuItemVisible → false؛ مسیر /announcements فعال می‌ماند)
  { key: ROUTES.ANNOUNCEMENTS, icon: <SoundOutlined />, label: 'اطلاعیه‌ها' },
  { key: ROUTES.NOTIFICATIONS, icon: <BellOutlined />, label: 'اعلان‌ها' },
  { key: ROUTES.USERS, icon: <TeamOutlined />, label: 'کاربران' },
  { key: ROUTES.ORGANIZATIONS, icon: <BankOutlined />, label: 'سازمان‌ها' },
  BILLING_MENU_ITEM,
  CALENDAR_MENU_ITEM,
  { key: ROUTES.SEARCH, icon: <SearchOutlined />, label: 'جستجو' },
  { key: ROUTES.REPORTS, icon: <BarChartOutlined />, label: 'گزارش‌ها' },
  ACTION_ITEMS_MENU_ITEM,
  { key: ROUTES.ROLES_AND_PERMISSIONS, icon: <SafetyCertificateOutlined />, label: 'نقش‌ها و دسترسی‌ها' },
  { key: ROUTES.AUDIT_EVENTS, icon: <HistoryOutlined />, label: 'تاریخچه فعالیت‌ها' },
];

/** آیتم‌های خارج از سایدبار سوپرادمین — فقط برای matching مسیر و بردکرامب نگه داشته می‌شوند. */
export const SUPER_ADMIN_MORE_MENU_DEFS = [
  { key: ROUTES.FILES, icon: <FolderOpenOutlined />, label: 'فایل‌ها' },
  { key: ROUTES.MINUTES, icon: <FileTextOutlined />, label: 'صورت جلسات' },
  { key: ROUTES.TRANSCRIPTS, icon: <ReadOutlined />, label: 'رونوشت‌ها' },
  { key: ROUTES.STT_JOBS, icon: <SoundOutlined />, label: 'تبدیل گفتار' },
  { key: ROUTES.WEBHOOK_DEAD_LETTERS, icon: <SettingOutlined />, label: 'صف وب‌هوک' },
];

export const SUPER_ADMIN_MORE_SUBMENU_KEY = 'super-admin-more';

export const TENANT_PRIMARY_MENU_DEFS = [
  DASHBOARD_MENU_ITEM,
  { key: ROUTES.MEETINGS, icon: <ScheduleOutlined />, label: 'جلسات' },
  { key: ROUTES.MEETING_GROUPS, icon: <FolderOpenOutlined />, label: 'کارگروه‌ها' },
  { key: ROUTES.ROOMS, icon: <HomeOutlined />, label: 'اتاق‌ها' },
  // اطلاعیه‌ها موقتاً از منو پنهان است (isMenuItemVisible → false؛ مسیر /announcements فعال می‌ماند)
  { key: ROUTES.ANNOUNCEMENTS, icon: <SoundOutlined />, label: 'اطلاعیه‌ها' },
  { key: ROUTES.NOTIFICATIONS, icon: <BellOutlined />, label: 'اعلان‌ها' },
  { key: ROUTES.ORG_MEMBERS, icon: <TeamOutlined />, label: 'اعضا' },
  { key: ROUTES.ORG_ROLES, icon: <SafetyCertificateOutlined />, label: 'نقش‌ها و دسترسی‌ها' },
  BILLING_MENU_ITEM,
  ACTION_ITEMS_MENU_ITEM,
  CALENDAR_MENU_ITEM,
  { key: ROUTES.AUDIT_EVENTS, icon: <HistoryOutlined />, label: 'تاریخچه فعالیت‌ها' },
  { key: ROUTES.REPORTS, icon: <BarChartOutlined />, label: 'گزارش‌ها' },
  { key: ROUTES.SEARCH, icon: <SearchOutlined />, label: 'جستجو' },
];

/** آیتم‌های خارج از سایدبار سازمان — فقط برای matching مسیر و بردکرامب نگه داشته می‌شوند. */
export const TENANT_MORE_MENU_DEFS = [
  { key: ROUTES.FILES, icon: <FolderOpenOutlined />, label: 'فایل‌ها' },
  { key: ROUTES.MINUTES, icon: <FileTextOutlined />, label: 'صورت جلسات' },
  { key: ROUTES.TRANSCRIPTS, icon: <ReadOutlined />, label: 'رونوشت‌ها' },
  { key: ROUTES.STT_JOBS, icon: <SoundOutlined />, label: 'تبدیل گفتار' },
];

export const TENANT_MORE_SUBMENU_KEY = 'tenant-more';

export const ACCOUNT_MENU_DEFS = [
  { key: ROUTES.PROFILE, icon: <UserOutlined />, label: 'پروفایل' },
  { key: ROUTES.SECURITY, icon: <SafetyCertificateOutlined />, label: 'امنیت حساب' },
  { key: ROUTES.WORKSPACE, icon: <BankOutlined />, label: 'سازمان من' },
  { key: ROUTES.SETTINGS, icon: <SettingOutlined />, label: 'تنظیمات' },
];

/** توضیحات کوتاه فارسی برای باکس‌های دسترسی سریع داشبورد */
export const MENU_DESCRIPTIONS = {
  [ROUTES.DASHBOARD]: 'مرکز تصمیم‌گیری و موارد نیازمند اقدام',
  [ROUTES.ORGANIZATIONS]: 'مدیریت سازمان‌های پلتفرم',
  [ROUTES.USERS]: 'مدیریت کاربران سیستم',
  [ROUTES.ROOMS]: 'تعریف و مدیریت اتاق‌ها',
  [ROUTES.NOTIFICATIONS]: 'مشاهده اعلان‌ها و وضعیت خواندن',
  [ROUTES.MEETINGS]: 'زمان‌بندی و برگزاری جلسات',
  [ROUTES.MEETING_GROUPS]: 'دسته‌بندی موضوعی و متمرکز جلسات',
  [ROUTES.SEARCH]: 'جستجو در محتوای سامانه',
  [ROUTES.AGENDA_TEMPLATES]: 'قالب‌های آماده دستور جلسه',
  [ROUTES.FILES]: 'مدیریت فایل‌ها و ضبط‌ها',
  [ROUTES.ACTION_ITEMS]: 'پیگیری اقدامات و وظایف',
  [ROUTES.MINUTES]: 'صورت‌جلسات و مستندات',
  [ROUTES.TRANSCRIPTS]: 'متن رونوشت جلسات',
  [ROUTES.STT_JOBS]: 'تبدیل گفتار به متن',
  [ROUTES.CALENDAR]: 'نمای تقویمی جلسات',
  [ROUTES.REPORTS]: 'گزارش‌ها و تحلیل‌ها',
  [ROUTES.ROLES_AND_PERMISSIONS]: 'نقش‌ها و سطوح دسترسی',
  [ROUTES.WEBHOOK_DEAD_LETTERS]: 'صف پیام‌های وب‌هوک ناموفق',
  [ROUTES.AUDIT_EVENTS]: 'رویدادهای مهم سازمان و سامانه',
  [ROUTES.ORG_MEMBERS]: 'مدیریت اعضای سازمان',
  [ROUTES.ORG_ROLES]: 'نقش‌ها و سطح دسترسی اعضای سازمان',
  [ROUTES.WORKSPACE]: 'تنظیمات و اطلاعات سازمان',
  [ROUTES.PROFILE]: 'پروفایل و حساب کاربری',
  [ROUTES.SECURITY]: 'رمز عبور، ورود دومرحله‌ای و نشست‌های فعال',
  [ROUTES.SETTINGS]: 'تنظیمات کلی پلتفرم',
  [ROUTES.BILLING]: 'اشتراک، فاکتور و پرداخت',
};

const dedupeByKey = (defs) => {
  const map = new Map();
  defs.forEach((item) => {
    if (item?.key != null) map.set(item.key, item);
  });
  return Array.from(map.values());
};

/**
 * همهٔ keyهای مسیر منو برای matching سایدبار — از تعریف‌های واقعی منو ساخته می‌شود
 * تا آیتم‌های جدید (مثل کارگروه‌ها) بدون hardcode فراموش نشوند.
 */
export function collectPanelMenuRouteKeys(extraKeys = []) {
  const defs = [
    ...MAIN_MENU_DEFS,
    ...SUPER_ADMIN_PRIMARY_MENU_DEFS,
    ...SUPER_ADMIN_MORE_MENU_DEFS,
    ...TENANT_PRIMARY_MENU_DEFS,
    ...TENANT_MORE_MENU_DEFS,
    ...ACCOUNT_MENU_DEFS,
  ];
  const keys = defs.map((item) => item?.key).filter(Boolean);
  return [...new Set([...keys, ...extraKeys])];
}

/**
 * انتخاب کلید منوی فعال بر اساس pathname.
 * طولانی‌ترین prefix برنده است تا /meeting-groups/123 روی گروه‌ها بماند نه داشبورد.
 */
export function resolveSidebarSelectedKey(pathname, routeKeys, fallbackKey) {
  const rawPath = String(pathname || '');
  const path = rawPath.startsWith('/meeting-collections/') ? ROUTES.MEETING_GROUPS : rawPath;
  if (!path) return fallbackKey ? [fallbackKey] : [];
  const match = (routeKeys || [])
    .filter((k) => path === k || path.startsWith(`${k}/`))
    .sort((a, b) => b.length - a.length);
  if (match.length) return [match[0]];
  return fallbackKey ? [fallbackKey] : [];
}

/**
 * ساخت آیتم‌های گرید دسترسی سریع از تعاریف منو با فیلتر دسترسی.
 *
 * @param {object[]} defs
 * @param {{ user: object, activeOrganization?: object, organizations?: object[] }} accessCtx
 * @param {{ excludeDashboard?: boolean, extraDefs?: object[] }} [options]
 */
export function buildFeatureLauncherItems(defs, accessCtx, options = {}) {
  const { excludeDashboard = true, extraDefs = [] } = options;
  const merged = dedupeByKey([...defs, ...extraDefs]);

  return merged
    .filter((item) => {
      if (excludeDashboard && item.key === ROUTES.DASHBOARD) return false;
      return isMenuItemVisible(item.key, accessCtx);
    })
    .map((item) => ({
      key: item.key,
      route: item.key,
      icon: item.icon,
      label: item.label,
      description: MENU_DESCRIPTIONS[item.key],
    }));
}
